module.exports = __webpack_public_path__ + "img/logo.954aaad9.svg";